// Plain, message-only toast — success or failure, no undo action. Distinct
// from ops_toasts_controller's stacking "ops-toasts:show" event, which is
// built around an undo affordance (label + actionLabel + url) and isn't a
// good fit for a bare confirmation. Originally lived inline in
// interaction_button_controller; extracted so pos_receipt_send_controller
// (and any future JSON-submitting button that needs the same plain
// confirm/error feedback) doesn't have to duplicate it.
const CONTAINER_ID = "ops-toast-container"

export function showOpsToast(message, level = "info") {
  const container = ensureContainer()
  const toast = document.createElement("div")
  toast.textContent = message
  toast.style.cssText = `
    background: ${level === "error" ? "#991b1b" : "#1f2937"};
    color: #fff;
    padding: 10px 14px;
    border-radius: 8px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.35);
    font-size: 13px;
    max-width: 360px;
    opacity: 0;
    transform: translateY(-8px);
    transition: opacity 150ms ease-out, transform 150ms ease-out;
  `
  container.appendChild(toast)
  requestAnimationFrame(() => {
    toast.style.opacity = "1"
    toast.style.transform = "translateY(0)"
  })
  setTimeout(() => {
    toast.style.opacity = "0"
    toast.style.transform = "translateY(-8px)"
    setTimeout(() => toast.remove(), 200)
  }, 5000)
}

export function csrfToken() {
  const el = document.querySelector("meta[name='csrf-token']")
  return el ? el.getAttribute("content") : ""
}

export function formatErrors(payload, fallback = "Action failed") {
  const errors = payload?.errors
  if (Array.isArray(errors) && errors.length > 0) {
    return errors.map((e) => e.full_message || e.message || e.detail).filter(Boolean).join(" · ")
  }
  return fallback
}

function ensureContainer() {
  let container = document.getElementById(CONTAINER_ID)
  if (container) return container
  container = document.createElement("div")
  container.id = CONTAINER_ID
  container.style.cssText = `
    position: fixed;
    top: 16px;
    right: 16px;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    gap: 8px;
    pointer-events: none;
  `
  document.body.appendChild(container)
  return container
}
